<template>

    <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
    >
        <template v-slot:activator="{ on }">

            <v-text-field
              :hide-details="message && !message.length"
              :value="customDateFormat"
              :label="label"
              :clearable="!!clearable"
              :clear-icon="clearIcon"
              :readonly="!canWrite"
              v-on="on"
              :single-line="singleLine"
              :solo="defaultValue"
              :disabled="disabled"
              flat
              Boolean
              :dense="dense"
              :error="error"
              :error-messages="message"
              :placeholder="placeholder"
              v-mask="mask"
              @click:clear="setValue(null)"
              @change="setValue"
              class="hummingbird-date-text-field-wrapper"
              :class="{'pt-1': todo, 'adjust-label': adjustLabel, 'pa-0 ma-0' : removePaddingMargin,'adjust-for-contact-details' : adjustForContactDetails}"
              @click="$emit('clicked')"
            >
                <template v-slot:prepend v-if="prepend_icon">
                    <hb-icon :class="[defaultValue === false ? 'pt-1': '']" @click="menu = true">mdi-calendar-blank</hb-icon>
                </template>
                <template v-slot:prepend-inner v-else>
                    <hb-icon  @click="menu = true" >mdi-calendar-blank</hb-icon>
                </template>
            </v-text-field>
              <!-- :class="{'pt-1': todo}"
            ></v-text-field> -->
            
            {{errors.first('hb-date-picker')}}
        </template>
        <v-date-picker
          no-title
          v-model="date"
          @change="setValue"
          show-current
          :max="max ? max : ''"
          :min="min ? min : ''"
        >
        </v-date-picker>

    </v-menu>
</template>

<script type="text/babel">
    import moment from 'moment';
    export default {
        name: 'HummingBirdDatepiker',
        components: {},
        data: (vm) => ({
            menu: false,
            date: '',
            dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)), 
        }),
        props: ["value", "label", "clearable", 'error','mask', 'dateFormat','canWrite', 'message', 'dense', "min", 'max', 'default_today', 'placeholder', 'solo','flat', 'prepend_icon','todo','change', 'singleLine', 'adjustLabel', 'removePaddingMargin','adjustForContactDetails','clearIcon', 'disabled'],
        filters: {
            formatDateOnly: function(value) {
                let date = null
                if(value){
                    date = moment(value).format('L'); 
                } 
                return date;
            }
        },
        mounted(){
            if(this.value){
                this.date = moment(this.value).format('YYYY-MM-DD');
                //this.date = moment(this.value).toDate().toISOString().substr(0, 10);
            } else if (this.default_today){
                this.date = this.currentDate;
            }
            this.$forceUpdate();
            //var now = moment().add(1, 'day').startOf('day').toDate();
        },
        computed:{
            defaultValue () {
                if(this.solo === false) return this.solo;
                return true;
            },
            computedDateFormatted () {
                
                if(!this.date) return;
                return this.formatDate(this.date); 
            },
            currentDate(){
              return moment().format('YYYY-MM-DD');
            },
            customDateFormat () {
                if (this.dateFormat) return moment(this.date).format(this.dateFormat);
                else return this.$options.filters.formatDate(this.date); 
            },

            // fieldValue: {
            //     get: function() {
            //         if(!this.value) return null;
            //         return moment(this.value, 'YYYY-MM-DD').startOf('day').format('MM/DD/YYYY')
            //     },
            //     set: function(value) {
            //         this.$emit('input',  moment(this.value).format('YYYY-MM-DD'))
            //     }
            // }
        },
        methods:{
            formatDate (date) {
                if (!date) return null;
                const [year, month, day] = date.split('-')
                return moment(date).format('L')
            },
            setValue(value){
                this.menu = false;

                // when user clear input it will remove value from date picker
                let newDate = ''
                if(value && moment(value).isValid()){
                    if((this.min && moment(this.min).isSameOrAfter(this.min)) || !this.min)
                    newDate = moment(value).format('YYYY-MM-DD')
                }
                this.$emit('input', newDate);
                this.$emit('change');
            },
        },
        watch: {
            value(){
                if(this.value) {
                    this.date = moment(this.value).format('YYYY-MM-DD');
                } else {
                    this.date = '';
                }
            },
            message(){
                if(this.date){
                    this.message = '';
                }
            }
        }
    }
</script>

<style scoped>
.adjust-for-contact-details {
    margin-top: -6px;
    margin-bottom: -6px;
    margin-left: -2px;
}

.adjust-for-contact-details >>> .v-input__control {
    min-height: 0 !important;
}

.adjust-for-contact-details >>> .v-input__slot {
    padding: 0 !important;
}
</style>

<style>

.hummingbird-date-text-field-wrapper .v-text-field__slot {
    padding-bottom: 2px !important;
}

.hummingbird-date-text-field-wrapper.v-input.error--text .v-input__prepend-outer .v-icon, .hummingbird-date-text-field-wrapper.v-input.error--text .v-input__prepend-inner .v-icon, .hummingbird-date-text-field-wrapper.v-input.error--text .v-input__append-inner .v-icon {
    color: #FB4C4C !important;
}

</style>
